import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from 'src/shared/data/data.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { trigger, transition, style, animate } from '@angular/animations';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export interface FAQ {
    faq_id: number;
    faq_question: string;
    faq_answer: string;
  }
@Component({
    selector: 'app-simple-product-page',
    templateUrl: './simple-product-page.component.html',
    styleUrls: ['./simple-product-page.component.scss'],
    animations: [
        trigger('fadeAnimation', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(10px)' }),
                animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
            ])
        ])
    ]
})

export class SimpleProductPageComponent implements OnInit, AfterViewInit {
    @ViewChild('mainImage') mainImageElement!: ElementRef;
    @ViewChild('zoomContainer') zoomContainer!: ElementRef;
    
    productId!: string;
    productDetails: any;
    tilesInfo: any;
    selectedImage: string = '';
    allProductImages: string[] = [];
    currentIndex: number = 0;
    activeTab: string = 'description';
    reviewForm: FormGroup;
    reviews: any[] = [];
    specifications: any[] = [];
    faqs: FAQ[] = [];    
    magnifierShow: boolean = false;
    magnifierPosX: number = 0;
    magnifierPosY: number = 0;
    zoomLevel: number = 2.5;
	
    allMedia: { type: 'image' | 'video', src: string }[] = [];
    selectedMedia: { type: 'image' | 'video', src: string };
    
    
    tileInfo1 = {
        skuCode: '453',
        size: '300x600mm',
        packPerBox: '8',
        landingPricePerSQFT: '533.87',
        coveragePerPcs: '5',
        coveragePerBox: '15.5',
        usage: 'Wall',
        bodyType: 'VERTIFIED',
        brandName: 'KAJARIA',
        baseColor: 'White',
        finish: 'MATT',
        weightPerBox: '20',
        landingPerPCS: '821.5',
        landingPerBOX: '3375'
    };
    
    pageTitle = [
        {
            bgImage: 'assets/img/product-banner.PNG',
            title: ''
        }
    ];
    
    
    facilityContent = [
        {
            icon: 'bx bx-box',
            title: 'Applications',
            paragraph: [
              'Kitchen', 'Bathroom', 'Living Room', 'Hall', 'Foyer', 
              'TV Unit', 'Balcony', 'Other Highlighting Walls'
            ]
          },
          {
            icon: 'bx bx-certification',
            title: 'Maintenance',
            paragraph: [
              'Use sweep/mop/vacuum to clean tiles regularly',
              'Use mild detergent or ceramic cleaner',
              'Avoid high concentrated acid/cleaners on glazed tiles'
            ]
          },
          {
            icon: 'bx bx-car',
            title: 'Installation',
            paragraph: [
              'Certified professional installation',
              'Detailed installation guidelines',
              'Comprehensive maintenance tips',
              'Pre-installation tile inspection recommended'
            ]
          }
    ];
    
    
    constructor(
        private route: ActivatedRoute,
        private dataService: DataService,
        private fb: FormBuilder,
		private sanitizer: DomSanitizer
    ) {
        this.reviewForm = this.fb.group({
            rating: [0, [Validators.required, Validators.min(1)]],
            title: ['', Validators.required],
            name: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            content: ['', [Validators.required, Validators.minLength(20)]],
            saveInfo: [false]
        });
    }
    
    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.productId = params.get('id')!;
            this.loadProductDetails();
        });
    }
    
    ngAfterViewInit() {
        setTimeout(() => {
            this.setupMagnifier();
        }, 100);
    }
    
    setupMagnifier() {
        const mainImage = this.mainImageElement.nativeElement;
        
        mainImage.addEventListener('mousemove', (e: MouseEvent) => {
            if (!this.magnifierShow) return;
            
            const rect = mainImage.getBoundingClientRect();
            
            const x = (e.clientX - rect.left) / rect.width;
            const y = (e.clientY - rect.top) / rect.height;
            
            this.magnifierPosX = Math.max(0, Math.min(1, x - (0.5 / this.zoomLevel)));
            this.magnifierPosY = Math.max(0, Math.min(1, y - (0.5 / this.zoomLevel)));
        });
        
        mainImage.addEventListener('mouseenter', () => {
            this.magnifierShow = true;
        });
        
        mainImage.addEventListener('mouseleave', () => {
            this.magnifierShow = false;
        });
    }
    
    selectImage(imageUrl: string, index: number) {
        this.selectedImage = imageUrl;
        this.currentIndex = index;
    }
    
    /* prevImage() {
        this.currentIndex = this.currentIndex === 0 ? 
            this.allProductImages.length - 1 : 
            this.currentIndex - 1;
        
        this.selectedImage = this.allProductImages[this.currentIndex];
    }
    
    nextImage() {
        this.currentIndex = (this.currentIndex + 1) % this.allProductImages.length;
        this.selectedImage = this.allProductImages[this.currentIndex];
    } */
	
	
	 prevImage() {
        const currentIndex = this.allMedia.findIndex(media => media.src === this.selectedMedia?.src);
        if (currentIndex > 0) {
          this.selectedMedia = this.allMedia[currentIndex - 1];
        }
      }
      
      nextImage() {
        const currentIndex = this.allMedia.findIndex(media => media.src === this.selectedMedia?.src);
        if (currentIndex < this.allMedia.length - 1) {
          this.selectedMedia = this.allMedia[currentIndex + 1];
        }
      }
    
    /* loadProductDetails(): void {
        this.dataService.getProductById(this.productId).subscribe({
            next: (product) => {
                if (product) {
                    console.log('1212',product)
                    // product.product_description = this.stripHtml(product.product_description);
                    this.productDetails = product.data;
                    this.pageTitle[0].title = product.data.product_name;
                    this.selectedImage = this.productDetails.product_image;
                    this.allProductImages = [
                        this.productDetails.product_image,
                        ...(this.productDetails.product_gallery || [])
                    ];
                    this.faqs=product.data.faqs;
                
                if (product.data.tiles_info) {                    
                    this.tilesInfo = product.data.tiles_info;
                }
                } else {
                    console.error('Product not found');
                }
            },
            error: (err) => console.error('Error loading product details', err)
        });
    }
     */
	 
	    loadProductDetails(): void {
        this.dataService.getProductById(this.productId).subscribe({
          next: (product) => {
            if (product) {
              this.productDetails = product.data;
              this.pageTitle[0].title = this.productDetails.product_name;
              this.selectedImage = this.productDetails.product_image;
              this.allProductImages = [
                this.productDetails.product_image,
                ...(this.productDetails.product_gallery || [])
              ];
      
              this.faqs = this.productDetails.faqs;
      
              if (product.data.tiles_info) {
                this.tilesInfo = product.data.tiles_info;
              }
      
              const images = this.productDetails.product_gallery || [];
              const videosRaw = this.productDetails.video_link || '';
              const videos = typeof videosRaw === 'string' ? videosRaw.split(',') : [];
              
              // Filter out empty video links before mapping
              const videoMedia = videos
                .map((video: string) => video.trim())
                .filter(video => video)  // Remove empty/null/whitespace strings
                .map(video => ({
                  type: 'video',
                  src: this.getYouTubeEmbedUrl(video),
                  thumbnail: this.getYouTubeThumbnailUrl(video)
                }));
              
              // Build allMedia array with only valid entries
              this.allMedia = [
                { type: 'image', src: this.productDetails.product_image },
                ...images.map((img: string) => ({ type: 'image', src: img })),
                ...videoMedia
              ];
      
              this.selectedMedia = this.allMedia[0]; // set default media
              console.log( "selectedMedia",this.selectedMedia )
            } else {
              console.error('Product not found');
            }
          },
          error: (err) => console.error('Error loading product details', err)
        });
      }
    stripHtml(html: string): string {
        return html.replace(/<\/?[^>]+(>|$)/g, "");
    }
    
    setActiveTab(tabId: string) {
        this.activeTab = tabId;
    }
    
    setRating(rating: number): void {
        this.reviewForm.get('rating')!.setValue(rating);
    }
    
    
    submitReview(): void {
        if (this.reviewForm.valid) {
            const newReview = {
                name: this.reviewForm.value.name,
                avatarSrc: 'assets/img/default-avatar.jpg',
                date: new Date(),
                rating: this.reviewForm.value.rating,
                title: this.reviewForm.value.title,
                content: this.reviewForm.value.content
            };
            
            this.reviews.unshift(newReview);
            this.reviewForm.reset({
                rating: 0,
                saveInfo: this.reviewForm.value.saveInfo
            });
        }
    }
	
	 getYouTubeEmbedUrl(url: string): SafeResourceUrl  {
        let videoId = '';
        // alert(url);
        if (url.includes('youtu.be/')) {
          videoId = url.split('youtu.be/')[1].split('?')[0];
        } else if (url.includes('youtube.com/watch')) {
          const params = new URLSearchParams(url.split('?')[1]);
          videoId = params.get('v') || '';
        }
        
        // return videoId ? `https://www.youtube.com/embed/${videoId}` : '';
        const embedUrl = videoId ? `https://www.youtube.com/embed/${videoId}` : '';
        return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
      }
	  
	 getYouTubeThumbnailUrl(url: string): string {
			let videoId = '';
			if (url.includes('youtu.be/')) {
			  videoId = url.split('youtu.be/')[1].split('?')[0];
			} else if (url.includes('youtube.com/watch')) {
			  const params = new URLSearchParams(url.split('?')[1]);
			  videoId = params.get('v') || '';
			}
			return videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : '';
		  }
}
